export const nav = {
    p1: `Vous pouvez gérer vos informations personnelles, changer votre mot de passe, vos intégrations, votre abonnement, et ajuster vos préférences utilisateur`,
    p2: `Mon compte`,
    p3: `Configurez les détails de votre hébergement, personnalisez les messages de bienvenue et les politiques, connectez-vous aux autorités locales pour l'envoi automatique des déclarations de voyageurs, et ajustez vos préférences opérationnelles`,
    p4: `Paramètres de l'hébergement`,
    p5: `Gérez et faites la promotion des services supplémentaires de votre hébergement, tels que la location d'espaces, les excursions et autres extras, afin d'améliorer l'expérience de vos voyageurs et d'augmenter vos revenus`,
    p6: `Ventes additionnelles`,
    p7: `Créer un nouvel hébergement`,
    p8: `E-mail de confirmation envoyé avec succès`,
    p9: `Hébergements`,
    p10: ``,
    p11: ``,
    p12: ``,
    p13: ``,
    p14: ``,
    p15: ``,
    p16: ``,
    p17: ``,
    p18: ``,
    p19: ``,
    p20: ``,
    p21: ``,
    p22: ``,
    p23: ``,
};
